import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";

import {
  catchError,
  map,
  switchMap,
  tap,
} from "rxjs/operators";
import { of } from "rxjs";
import { TaxIdentificationNumberDetailsActions } from "../../actions/tax-identification-number-details/tax-identification-number-details.actions";
import { TaxIdentificationNumberDetailsService } from "@services/tax-identification-number-details.service";

import { MatDialog } from "@angular/material/dialog";
import { EditAddTinModalComponent } from "@components/modals/edit-add-tin-modal/edit-add-tin-modal.component";
import { ConfirmationModalComponent } from "@components/confirmation-modal/confirmation-modal.component";
import { Store } from "@ngrx/store";

@Injectable()
export class TaxIdentificationNumberDetailsEffects {

  openAddTinPressed$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(TaxIdentificationNumberDetailsActions.openAddTinPressed),
        tap(() => {
          this.dialog.open(EditAddTinModalComponent, {
            data: {
              title: "Create TIN",
            },
          });
        })
      ),
    { dispatch: false }
  );

  openEditTinPressed$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(TaxIdentificationNumberDetailsActions.openEditTinPressed),
        tap((action) => {
          this.dialog.open(EditAddTinModalComponent, {
            data: {
              title: "Create TIN",
              tin: action.tin
            },
          });
        })
      ),
    { dispatch: false }
  );

  openDeleteTinPressed$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(TaxIdentificationNumberDetailsActions.openDeleteTinPressed),
        tap((action) => {
          
          const dialogRef = this.dialog.open(ConfirmationModalComponent, {
            data: { title: 'Delete TIN Confirmation',
              content: `Are you sure you want to delete: ${action.name}?` },
          });

          dialogRef.afterClosed().subscribe(result => {
            if (result) {
              this.store.dispatch(TaxIdentificationNumberDetailsActions.deleteTIN({id: action.id}))
            } else {
              dialogRef.close();
            }
          });

        })
      ),
    { dispatch: false }
  );

  createOrganizationTin$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(TaxIdentificationNumberDetailsActions.addTINSave),
      switchMap((action) => {
        return this.tinDetailsService.createOrganizationTIN(action.data).pipe(
          map((data) =>
            TaxIdentificationNumberDetailsActions.addTINSuccess({ data: data })
          ),
          catchError((error) =>
            of(TaxIdentificationNumberDetailsActions.addTINFailure({ error }))
          )
        );
      })
    );
  });

  updateOrganizationTin$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(TaxIdentificationNumberDetailsActions.editTIN),
      switchMap((action) => {
        return this.tinDetailsService.updateOrganizationTIN(action.data).pipe(
          map((data) =>
            TaxIdentificationNumberDetailsActions.editTINSuccess({ data: data })
          ),
          catchError((error) =>
            of(TaxIdentificationNumberDetailsActions.editTINFailure({ error }))
          )
        );
      })
    );
  });

  deleteOrganizationTin$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(TaxIdentificationNumberDetailsActions.deleteTIN),
      switchMap((action) => {
        return this.tinDetailsService.deleteOrganizationTIN(action.id).pipe(
          map((data) =>
            TaxIdentificationNumberDetailsActions.deleteTINSuccess({
              id: action.id,
            })
          ),
          catchError((error) =>
            of(
              TaxIdentificationNumberDetailsActions.deleteTINFailure({ error })
            )
          )
        );
      })
    );
  });

  constructor(
    private actions$: Actions,
    private tinDetailsService: TaxIdentificationNumberDetailsService,
    private dialog: MatDialog,
    private store: Store
  ) {}
}
